import React from 'react';

import {MeltingTempMethod, MeltingTempPreferences, NucleotideType} from 'biojs/BioConstants';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';

export const METHOD_DESCRIPTIONS: {[key in MeltingTempMethod]: string} = {
  [MeltingTempMethod.primer3]: 'SantaLucia 1998 (recommended)',
  [MeltingTempMethod.thermo]: 'Modified Breslauer 1986 (Phusion, Phire, DyNAzyme)',
  [MeltingTempMethod.xia]: 'Xia 1998',
};

interface MeltingTempModalDropdownProps {
  meltingTempOptions: MeltingTempPreferences;
  nucleotideType: NucleotideType;
  setMeltingTempOptions: (prefs: MeltingTempPreferences) => void;
}

export default function MeltingTempModalDropdown({
  meltingTempOptions,
  nucleotideType,
  setMeltingTempOptions,
}: MeltingTempModalDropdownProps): JSX.Element {
  return (
    <div className="row">
      <div className="col col-md-2">
        <FieldLabel label="Algorithm" isRequired={true} />
      </div>
      <div className="col col-md-9">
        <SelectDropdown
          disabled={nucleotideType === NucleotideType.RNA}
          displayName={METHOD_DESCRIPTIONS[meltingTempOptions.method]}
          menu={
            <Menu>
              {Object.keys(METHOD_DESCRIPTIONS)
                .filter(
                  (method: MeltingTempMethod) =>
                    nucleotideType === NucleotideType.RNA || method !== MeltingTempMethod.xia
                )
                .map((method: MeltingTempMethod) => (
                  <Option
                    key={method}
                    value={method}
                    onSelect={(method: MeltingTempMethod) => {
                      setMeltingTempOptions({
                        ...meltingTempOptions,
                        method,
                      });
                    }}
                  >
                    {METHOD_DESCRIPTIONS[method]}
                  </Option>
                ))}
            </Menu>
          }
        />
      </div>
    </div>
  );
}
